import React from "react";
import moment from "moment";
import { chartcolors, chartgroupmentcolors } from "variables/lists/colors";
import { color } from "d3";
import { lists } from 'variables/lists/patrimoine.js';
import {
    ReferenceArea,
} from 'recharts';
import { charttext } from "variables/chart";
import { NumericFormat } from 'react-number-format';
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { chart } from "highcharts";

export function ConvertData(chart) {
    let data = [];
    if (chart.xaxisscale && chart.xaxisscale === 'time') { //graphique temporel
        if (!chart.distributiongroupment || chart.distributiongroupment === 'no') { //pas de groupement
            //création de tous les ticks
            chart.series.forEach((serie) => {
                if (serie.values) {
                    serie.values.forEach((value) => {
                        if (!data.find((timedata) => timedata.timestamp == value.time)) { //unicité des ticks
                            data.push({ timestamp: value.time });
                        }
                    });
                }
            }
            );
            //pousse les valeurs des séries sur les ticks, si les valeurs ne sont pas nulles, sur un uuid de série auto généré avant
            chart.series.forEach((serie) => {
                if (serie.values) {
                    serie.values.forEach((value) => {
                        value.value != null && (data.find((timedata) => timedata.timestamp == value.time)[serie.uuid] = value.value);
                    });
                }
            });
        }
        else { //temporel avec groupement
            let groupments = [];
            chart.series.forEach((serie) => {
                if (serie.values) {
                    serie.values.forEach((value) => {
                        //création du tick
                        if (!data.find((timedata) => timedata.timestamp == value.time)) {
                            data.push({ timestamp: value.time });
                        }
                        //on crée pour chaque tick dans data la clé correspondant à la série groupée
                        let timedata = data.find((timedata) => timedata.timestamp == value.time);
                        if (!serie.groupment)
                            serie.groupment = "unknown";
                        timedata[serie.originalid + "_" + serie.groupment + "_arr"] = [];
                    });
                    //on garde en mémoire les différents groupements et les séries correspondantes
                    if (!groupments.find((groupment) => groupment.serie == serie.originalid)) {
                        groupments.push({ serie: serie.originalid, method: serie.groupmentmethod, list: [] });
                    }
                    let groupment = groupments.find((groupment) => groupment.serie == serie.originalid);
                    if (!groupment.list.includes(serie.groupment)) {
                        groupment.list.push(serie.groupment);
                    }
                }
            });

            //on pousse les données des séries sur les groupements dans les données
            chart.series.forEach((serie) => {
                if (serie.values) {
                    serie.values.forEach((value) => {
                        if (value.value != null) {
                            data.find((timedata) => timedata.timestamp == value.time)[serie.originalid + "_" + serie.groupment + "_arr"].push(value.value);
                        }
                    });
                }
            });

            //on crée le total par groupement
            data.forEach((serie) => {
                let total = 0;
                groupments.forEach((groupment) => {
                    groupment.list.forEach((key) => {
                        let valarray = serie[groupment.serie + "_" + key + "_arr"];
                        if (valarray && valarray.length > 0) {
                            let result = aggregate(valarray, groupment.method);
                            total += result;
                            serie[groupment.serie + "_" + key] = result;
                        }

                    });
                    serie[groupment.serie + "_total"] = total;
                });
            });
        }
        data.sort((a, b) => a.timestamp - b.timestamp);
    }
    else {
        if (chart.distribution === 'no') {
            let val = {};
            val.group = 'all';
            chart.series.forEach((serie) => {
                if (serie.values && serie.values.length > 0) {
                    val[serie.uuid] = serie.values[0].value;
                }
            }
            );
            data.push(val);
        }
        else {
            if (!chart.distributiongroupment || chart.distributiongroupment === 'no') {
                chart.series.forEach((serie) => {
                    if (serie.originalid) {
                        if (!data.find((groupdata) => groupdata.originalid == serie.originalid)) {
                            data.push({ originalid: serie.originalid, group: serie.originalname });
                        }
                    }
                });
                chart.series.forEach((serie) => {
                    if (serie.values) {
                        if (serie.values && serie.values.length > 0) {
                            data.find((groupdata) => groupdata.originalid == serie.originalid)[serie.groupid] = Number(serie.values[0].value);
                        }
                    }
                });
            }
            else {
                let groupments = [];

                chart.series.forEach((serie) => {
                    if (serie.originalid) {
                        if (!data.find((groupdata) => groupdata.originalid == serie.originalid)) {
                            data.push({ originalid: serie.originalid, group: serie.originalname, });

                        }
                        let groupdata = data.find((groupdata) => groupdata.originalid == serie.originalid);
                        if (!serie.groupment)
                            serie.groupment = "unknown";
                        groupdata[serie.groupment + "_arr"] = [];
                        if (!groupments.find((groupment) => groupment.serie == serie.originalid)) {
                            groupments.push({ serie: serie.originalid, method: serie.groupmentmethod, list: [] });
                        }
                        let groupment = groupments.find((groupment) => groupment.serie == serie.originalid);
                        if (!groupment.list.includes(serie.groupment)) {
                            groupment.list.push(serie.groupment);
                        }
                    }
                });

                chart.series.forEach((serie) => {
                    if (serie.values) {
                        if (serie.values && serie.values.length > 0) {
                            data.find((groupdata) => groupdata.originalid == serie.originalid)[serie.groupment + "_arr"].push(serie.values[0].value);
                        }
                    }
                });
                data.forEach((serie) => {
                    let total = 0;
                    let groupment = groupments.find((groupment) => groupment.serie == serie.originalid);
                    groupment.list.forEach((key) => {
                        let valarray = serie[key + "_arr"];
                        let result = aggregate(valarray, groupment.method);
                        total += result;
                        serie[key] = result;
                    });
                    serie.total = total;
                });
            }
        }

    }
    return data;
}

export function GetHeatMapData(chart) {
    let chartdata = {};
    let mindate;
    let maxdate;
    let displaydata = chart.heatmapparameters.heatmapdisplay;

    if (chart.series.length === 1) {
        let serie = chart.series[0];
        serie.values.forEach((value) => {
            if (value.value != null) {
                if (!mindate && !maxdate) {
                    mindate = moment(value.time);
                    maxdate = moment(value.time);
                }
                else {
                    if (mindate.isAfter(moment(value.time)))
                        mindate = moment(value.time);
                    else if (maxdate.isBefore(moment(value.time)))
                        maxdate = moment(value.time);
                }
            }
        });

        let xaxis = [];
        let yaxis = [];
        let data = [];
        let min;
        let max;
        if (displaydata === 'hourday') {
            mindate.set('hour', 0);
            mindate.set('minute', 0);
            mindate.set('second', 0);

            maxdate.set('hour', 23);
            maxdate.set('minute', 0);
            maxdate.set('second', 0);

            yaxis = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12',
                '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',];

            let currentdate = mindate;
            let x = 0;
            while (currentdate.isBefore(maxdate)) {
                let date = new Date(currentdate.get('year'), currentdate.get('month'), currentdate.get('date'));
                xaxis.push(date);
                for (let i = 0; i < 24; i++) {
                    let time = new Date();
                    time.setTime(date.getTime());
                    time.setHours(i);
                    time.setMinutes(0);
                    time.setSeconds(0);
                    time.setMilliseconds(0);

                    let val = serie.values.find((val) => val.time === time.getTime());
                    if (val) {
                        data.push([x, i, val.value]);
                        if (!min && !max) {
                            min = val.value;
                            max = val.value;
                        }
                        else if (min > val.value)
                            min = val.value;
                        else if (max < val.value)
                            max = val.value;
                    }
                }
                x++;
                currentdate.add(1, 'day');
            }
            // console.log(data);
            // console.log(xaxis);
        }
        else if (displaydata === 'daymonth') {
            mindate.set('date', 1);
            mindate.set('hour', 0);
            mindate.set('minute', 0);
            mindate.set('second', 0);

            maxdate.add('month', 1);
            maxdate.set('date', 1);
            maxdate.add('day', -1);
            maxdate.set('hour', 23);
            maxdate.set('minute', 0);
            maxdate.set('second', 0);

            console.log(mindate, maxdate);
            yaxis = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12',
                '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24',
                '25', '26', '27', '28', '29', '30', '31'];

            let currentdate = mindate;
            let x = 0;
            while (currentdate.isBefore(maxdate)) {
                let date = new Date(currentdate.get('year'), currentdate.get('month'));
                xaxis.push(date);
                for (let i = 1; i <= 31; i++) {
                    let time = new Date();
                    time.setTime(date.getTime());
                    time.setDate(i);
                    time.setHours(0);
                    time.setMinutes(0);
                    time.setSeconds(0);
                    time.setMilliseconds(0);

                    let val = serie.values.find((val) => val.time === time.getTime());
                    if (val) {
                        data.push([x, i, val.value]);
                        if (!min && !max) {
                            min = val.value;
                            max = val.value;
                        }
                        else if (min > val.value)
                            min = val.value;
                        else if (max < val.value)
                            max = val.value;
                    }
                }
                x++;
                currentdate.add(1, 'month');
            }
        }
        chartdata.xaxis = xaxis;
        chartdata.yaxis = yaxis;
        chartdata.data = data;
        chartdata.min = min;
        chartdata.max = max;
    }
    return chartdata;
}

export function ConvertDataForTwoPies(data, groupedseries) {
    let datatwopies = [];
    data.forEach((serie) => {
        groupedseries.forEach((groupedserie) => {
            let val = serie[groupedserie.groupid];
            let name = groupedserie.groupname;
            let color = groupedserie.color;
            datatwopies.push({ name: name, value: val, color: color, serie: serie.group });
        });
    });
    return datatwopies;
}

export function GetXLSXData(chart, data, groupedseries) {
    let xlsxdata = [];
    if (chart.xaxisscale === 'time') {
        let headers = [];
        headers.push({ type: 'string', value: 'Date' });
        groupedseries.forEach((groupedserie) => {
            headers.push({ type: 'string', value: groupedserie.groupname });
        });
        xlsxdata.push(headers);
        data.forEach((serie) => {
            let line = [];
            line.push({ type: 'string', value: moment(serie.timestamp).utc().format("DD/MM/YYYY HH:mm") });
            groupedseries.forEach((groupedserie) => {
                line.push({ type: 'number', value: serie[groupedserie.groupid] });
            });
            xlsxdata.push(line);
        });
        chart.xlsxdata = xlsxdata;
    }
    else {
        let headers = [];
        headers.push({ type: 'string', value: '' });
        data.forEach((serie) => {
            headers.push({ type: 'string', value: serie.group });
        });
        xlsxdata.push(headers);
        groupedseries.forEach((groupedserie) => {
            let line = [];
            line.push({ type: 'string', value: groupedserie.groupname });
            data.forEach((serie) => {
                line.push({ type: 'number', value: serie[groupedserie.groupid] });
            });
            xlsxdata.push(line);
        });
        chart.xlsxdata = xlsxdata;
    }
    return xlsxdata;
}

export function GetXLSXDataHeatmap(chart) {
    let xlsxdata = [];

    if (chart.series.length === 1) {
        let headers = [];
        headers.push({ type: 'string', value: 'Date' });
        headers.push({ type: 'string', value: chart.series[0].name });

        xlsxdata.push(headers);

        let data = chart.series[0].values;
        data.forEach((d) => {
            let line = [];
            line.push({ type: 'string', value: moment(d.time).utc().format("DD/MM/YYYY HH:mm") });
            line.push({ type: 'number', value: d.value });

            xlsxdata.push(line);
        });
        chart.xlsxdata = xlsxdata;
    }



    return xlsxdata;
}

export function GetXLSXDataTab(chart, groupedseries) {
    let xlsxdata = [];

    let headers = [];
    headers.push({ type: 'string', value: '' });
    let columnstab = [];
    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!columnstab.find((columndata) => columndata.originalid == serie.originalid)) {
                columnstab.push({ originalid: serie.originalid, name: serie.originalname, uuid: serie.uuid, position: serie.position });
            }
        }
    });
    columnstab.sort((a, b) => a.position - b.position);
    columnstab.forEach((serie) => {
        headers.push({ type: 'string', value: serie.name });
    });

    xlsxdata.push(headers);
    groupedseries.forEach((groupedserie) => {
        let line = [];
        line.push({ type: 'string', value: groupedserie.groupname });
        columnstab.forEach((serie) => {
            line.push({ type: 'number', value: groupedserie[serie.uuid] });
        });
        xlsxdata.push(line);
    });
    chart.xlsxdata = xlsxdata;
    return xlsxdata;
}

export function GetXLSXDataTabEquipment(chart, groupedseries) {
    let xlsxdata = [];

    let headers = [];
    headers.push({ type: 'string', value: '' });
    let columnstab = [];
    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!columnstab.find((columndata) => columndata.originalid == serie.originalid)) {
                columnstab.push({ originalid: serie.originalid, name: serie.originalname, uuid: serie.uuid, position: serie.position });
            }
        }
    });
    columnstab.sort((a, b) => a.position - b.position);
    columnstab.forEach((serie) => {
        headers.push({ type: 'string', value: serie.name });
    });

    xlsxdata.push(headers);
    groupedseries.forEach((groupedserie) => {
        let line = [];
        line.push({ type: 'string', value: groupedserie.equipmentname });
        columnstab.forEach((serie) => {
            line.push({ type: 'number', value: groupedserie[serie.uuid] });
        });
        xlsxdata.push(line);
    });
    chart.xlsxdata = xlsxdata;
    return xlsxdata;
}

function aggregate(valarray, method) {
    let result;
    if (!method || method === 'SUM') {
        result = 0;
        valarray.forEach((val) => {
            result += Number(val);
        });
    }
    else if (method === 'AVG') {
        let sum = 0;
        let count = valarray.length;
        valarray.forEach((val) => sum += Number(val));
        result = sum / count;
    }
    else if (method === 'MIN') {
        let min;
        valarray.forEach((val) => {
            if (!min || min > Number(val))
                min = Number(val);
        });
        result = min;
    }
    else if (method === 'MAX') {
        let max;
        valarray.forEach((val) => {
            if (!max || max < Number(val))
                max = Number(val);
        });
        result = max;
    }
    return result;
}

export function getTabTotal(chart, groupedseries) {
    let total = { groupid: -2, groupname: "Total", total: true };

    let columnstab = [];
    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!columnstab.find((columndata) => columndata.originalid == serie.originalid)) {
                columnstab.push({ originalid: serie.originalid, name: serie.originalname, uuid: serie.uuid, position: serie.position, serieagg: serie.serieagg });
            }
        }
    });
    columnstab.forEach((serie) => {
        let valarr = [];
        groupedseries.forEach((groupedserie) => {
            valarr.push(groupedserie[serie.uuid]);
        });
        let val = aggregate(valarr, serie.serieagg);
        total[serie.uuid] = val;
    });
    groupedseries.push(total);

}

export function getGroupedSeriesByGroupIdForTab(chart) {
    let group = [];

    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!group.find((groupdata) => groupdata.groupid == serie.groupid)) {
                group.push({ groupid: serie.groupid, groupname: serie.groupname });
            }
            let gp = group.find((groupdata) => groupdata.groupid == serie.groupid);
            if (serie.values.length > 0)
                gp[serie.uuid] = serie.values[0].value;
        }
    });
    return group;
}

export function getGroupedSeriesByEquipmentIdForTab(chart) {
    let group = [];

    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!group.find((groupdata) => groupdata.equipmentid == serie.equipmentid)) {
                group.push({ equipmentid: serie.equipmentid, equipmentname: serie.equipmentname });
            }
            let gp = group.find((groupdata) => groupdata.equipmentid == serie.equipmentid);
            if (serie.values.length > 0)
                gp[serie.uuid] = serie.values[0].value;
        }
    });
    return group;
}

export function getGroupedSeriesByGroupmentForTab(chart) {
    let group = [];
    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!serie.groupment)
                serie.groupment = "undefined"
            if (!group.find((groupdata) => groupdata.groupid == serie.groupment)) {
                group.push({ groupid: serie.groupment, groupname: getGroupmentPrettyName(chart.distributiongroupment, serie.groupment) });
            }
        }
        let gp = group.find((groupdata) => groupdata.groupid == serie.groupment);
        if (!gp.series)
            gp.series = [];
        if ((!serie.datatype || serie.datatype === 'number') && serie.values.length > 0) {
            if (!gp[serie.uuid]) {
                gp.series.push({ uuid: serie.uuid, serieagg: serie.serieagg || "SUM" });
                gp[serie.uuid] = [];
            }
            gp[serie.uuid].push(serie.values[0].value);
        }
    });
    group.forEach((gp) => {
        gp.series.forEach((serie) => {
            gp[serie.uuid] = aggregate(gp[serie.uuid], serie.serieagg);
        });
    });
    return group;
}
export function getTabEquipmentColumns(chart) {
    let columns = [];
    columns.push({
        name: charttext.equipment,
        selector: (row) => !row.total ? row.equipmentname : 'zzzzzzzzzzzzzz',
        sortable: true,
        // maxWidth: "12rem",
        grow: 1,
        cell: (row) => row.equipmentname
    });

    let columnstab = [];
    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!columnstab.find((columndata) => columndata.originalid == serie.originalid)) {
                columnstab.push({ originalid: serie.originalid, name: serie.originalname, uuid: serie.uuid, position: serie.position });
            }
        }
    });
    columnstab.sort((a, b) => a.position - b.position);

    columnstab.forEach((serie) => {
        columns.push({
            name: serie.name,
            selector: (row) => row[serie.uuid],
            sortable: true,
            right: (!serie.datatype || serie.datatype === 'number') ? true : false,
            //maxWidth: "12rem",
            cell: (row) => (!serie.datatype || serie.datatype === 'number') ? <NumericFormat value={row[serie.uuid]} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} decimalScale={2} /> : row[serie.uuid]
        });
    });

    return columns;
}

export function getTabColumns(chart) {
    let columns = [];
    columns.push({
        name: charttext.group,
        selector: (row) => !row.total ? row.groupname : 'zzzzzzzzzzzzzz',
        sortable: true,
        // maxWidth: "12rem",
        grow: 1,
        cell: (row) => !row.total ? <AdvancedSearchContext.Consumer>
            {(({ setChartIdGroup, setSelectedNodesInfo, setOutofcontextclic }) => {
                return (
                    <div
                        onClick={() => {
                            setOutofcontextclic("" + row.groupid);
                            setChartIdGroup([row.groupid]);
                            setSelectedNodesInfo(row.groupname);
                        }}
                        style={{ cursor: "pointer" }}
                    >
                        {row.groupname}
                    </div>)
            })}
        </AdvancedSearchContext.Consumer> : row.groupname
    });

    let columnstab = [];
    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!columnstab.find((columndata) => columndata.originalid == serie.originalid)) {
                columnstab.push({ originalid: serie.originalid, name: serie.originalname, uuid: serie.uuid, position: serie.position });
            }
        }
    });
    columnstab.sort((a, b) => a.position - b.position);

    columnstab.forEach((serie) => {
        columns.push({
            name: serie.name,
            selector: (row) => ((!serie.datatype || serie.datatype === 'number') &&  row[serie.uuid]) ? Number(row[serie.uuid])  : row[serie.uuid] ? row[serie.uuid] : -999999999999999,
            sortable: true,
            right: (!serie.datatype || serie.datatype === 'number') ? true : false,
            //maxWidth: "12rem",
            cell: (row) => ((!serie.datatype || serie.datatype === 'number') &&  row[serie.uuid]) ? <NumericFormat value={row[serie.uuid]} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} decimalScale={2} /> : row[serie.uuid] ? row[serie.uuid] : ''
        });
    });

    return columns;
}

export function getGroupedSeriesByGroupId(chart) {
    let group = [];
    let colorindex = 0;
    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!group.find((groupdata) => groupdata.groupid == serie.groupid)) {
                group.push({ groupid: serie.groupid, groupname: serie.groupname, color: chartcolors[colorindex], stackId: serie.stackId, type: serie.type, position: serie.position, yaxis: serie.yaxis });
                colorindex++;
                if (colorindex > 9)
                    colorindex = 0;
            }
        }
    });
    return group;
}

export function getGroupedSeriesByGroupment(chart) {
    let group = [];
    let colorindex = 0;
    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!group.find((groupdata) => groupdata.groupid == serie.groupment)) {
                group.push({ groupid: serie.groupment, groupname: getGroupmentPrettyName(chart.distributiongroupment, serie.groupment), color: chartgroupmentcolors[colorindex], type: serie.type, position: serie.position });
                colorindex++;
                if (colorindex > 9)
                    colorindex = 0;
            }
        }
    });
    return group;
}

export function getGroupedSeriesByGroupmentAndSerie(chart) {
    let group = [];
    let colorindex = 0;
    chart.series.forEach((serie) => {
        if (serie.originalid) {
            if (!group.find((groupdata) => groupdata.groupid == (serie.originalid + "_" + serie.groupment))) {
                group.push({
                    groupid: serie.originalid + "_" + serie.groupment
                    , groupname: serie.originalname + " (" + getGroupmentPrettyName(chart.distributiongroupment, serie.groupment) + ")"
                    , color: chartgroupmentcolors[colorindex]
                    , type: serie.type
                    , position: serie.position
                });
                colorindex++;
                if (colorindex > 9)
                    colorindex = 0;
            }
        }
    });
    group.sort((a, b) => a.position - b.position);
    return group;
}

export function getGroupedSeriesByUUID(chart) {
    let group = [];
    let colorindex = 0;
    chart.series.forEach((serie) => {
        if (serie.uuid) {
            if (!group.find((groupdata) => groupdata.groupid == serie.uuid)) {
                // group.push({ groupid: serie.uuid, groupname: serie.name, color: chartcolors[colorindex], yaxis: serie.yaxis, stackId: serie.stackId });
                // colorindex++;
                group.push({ groupid: serie.uuid, groupname: serie.name, color: serie.color || chartcolors[colorindex], yaxis: serie.yaxis, stackId: serie.stackId, type: serie.type, position: serie.position });
                colorindex++;
                if (colorindex > 9)
                    colorindex = 0;
            }
        }
    });
    group.sort((a, b) => a.position - b.position);
    return group;
}

function getGroupmentPrettyName(groupmenttype, groupment) {
    let prettyname = "";
    if (groupmenttype === 'parameters.activity.activitytype') {
        prettyname = lists.activityData.find((obj) => obj.id === groupment)?.name || 'Inconnu';
    }
    else {
        prettyname = groupment;
    }
    return prettyname;
}

export const CustomizedReferenceLabel = (props) => {
    return (
        <>
            <text offset={props.offset} x={(props.viewBox?.width) / 2} y={(props.viewBox?.y)} fill="black" class="recharts-text recharts-label" text-anchor="middle">
                <tspan x={(props.viewBox?.width) / 2}>{props.text}</tspan>
            </text>
        </>
    );
}

export const convertUrlColorToHexa = (urlcolor) => {
    // console.log(urlcolor);
    if (urlcolor === 'url(#colorRed)')
        return '#C53F3F';
    else if (urlcolor === 'url(#colorOrange)')
        return '#FF763A';
    else if (urlcolor === 'url(#colorYellow)')
        return '#D6D22F';
    else if (urlcolor === 'url(#colorGreen)')
        return '#91C73C';
    else if (urlcolor === 'url(#colorBlue)')
        return '#3E8FC6';
    else if (urlcolor === 'url(#colorPurple)')
        return '#6B3CC8';
    else if (urlcolor === 'url(#colorGrey)')
        return '#9798A0';
    else if (urlcolor === 'url(#dpeA)')
        return '#008A32';
    else if (urlcolor === 'url(#dpeB)')
        return '#91C73C';
    else if (urlcolor === 'url(#dpeC)')
        return '#D6D22F';
    else if (urlcolor === 'url(#dpeD)')
        return '#FFFF66';
    else if (urlcolor === 'url(#dpeE)')
        return '#F8BB00';
    else if (urlcolor === 'url(#dpeF)')
        return '#FF763A';
    else if (urlcolor === 'url(#dpeG)')
        return '#C53F3F';
    else
        return urlcolor;
}

export const CustomTooltip = ({ active, payload, label, xaxistimetick, unit, chart, hidelabel, zoom }) => {
    //  console.log(active, payload, label, xaxistimetick, unit);
    //  console.log(chart);
    if (active && chart && chart.type === 'indicatorchart') {
        let actualpayload = payload ? payload[0]?.name : '';
        let actualsegment = chart?.indicatorparameters?.gauge?.segments?.find((segment) => segment.name === actualpayload);
        return (
            <div style={{
                backgroundColor: 'rgba(255, 255,255, 0.85)', borderRadius: '4px', padding: '10px', paddingLeft: "10px",
                border: "1px solid #999999"
            }}>
                <p style={{ textAlign: 'center' }}><b>{actualpayload}</b></p>
                <p>{'de ' + actualsegment.min + chart.yaxis1unit}</p>
                <p>{'à ' + actualsegment.max + chart.yaxis1unit}</p>
            </div>
        );
    }
    else if (xaxistimetick && active && payload && payload.length) {
        return (
            <div style={{
                backgroundColor: 'rgba(255, 255,255, 0.85)', borderRadius: '4px', padding: '10px', paddingLeft: "10px",
                border: "1px solid #999999"
            }}>
                {/* {zoom ? <>zoom</> : <></>} */}
                <p style={{}}>{xaxistimetick === '10minutes' ? moment(label).utc().format('DD/MM/yyyy HH:mm:ss') :
                    xaxistimetick === 'hour' ? moment(label).utc().format('DD/MM/yyyy HH:mm:ss') :
                        xaxistimetick === 'day' ? moment(label).utc().format('DD/MM/yyyy')
                            : xaxistimetick === 'week' ? moment(label).utc().format('DD/MM/yyyy')
                                : xaxistimetick === 'month' ? moment(label).utc().format('MM/yyyy')
                                    : xaxistimetick === 'year' ? moment(label).utc().format('yyyy') : ''}</p>
                {
                    payload.map((obj) =>
                        <p style={{ color: obj.color }}>{obj.name + ' : ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(obj.value) + ' ' + (obj.unit || '')}</p>)
                }

            </div>
        );
    }
    else if (active && payload && payload.length) {
        return (
            <div style={{
                backgroundColor: 'rgba(255, 255,255, 0.85)', borderRadius: '4px', padding: '10px', paddingLeft: "10px",
                border: "1px solid #999999"
            }}>
                {
                    hidelabel ? <></> :
                        <p style={{}}><b>{label}</b></p>
                }

                {
                    payload.map((obj) =>
                        <p style={{ color: obj.color }}>{obj.name + ' : ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(obj.value) + ' ' + (obj.unit || unit || chart.yaxis1unit || '')}</p>)
                }

            </div>
        );
    }
    return null;
}

export const getAxisYDomain = (from, to, ref, offset, dataserver) => {
    const fromIndex = dataserver.findIndex((x) => x.timestamp === from);
    const toIndex = dataserver.findIndex((x) => x.timestamp === to);
    const refData = dataserver.slice(fromIndex - 1, toIndex);
    let [bottom, top] = [refData[0][ref], refData[0][ref]];
    refData.forEach((d) => {
        if (d[ref] > top) top = d[ref];
        if (d[ref] < bottom) bottom = d[ref];
    });

    return [(bottom | 0) - offset, (top | 0) + offset];
};


export const createOccupationArea = (usedata, entityParameters) => {
    //console.log(entityParameters);
    let occupationareas = [];
    let occupationschedule = entityParameters?.parameters?.occupation;
    if (occupationschedule && usedata && usedata.length > 0) {
        let scheduleinminutes = [];
        for (let i = 0; i < (7 * 24 * 60); i++) {
            scheduleinminutes.push({ timeofweek: i, before: 0, now: 0 });
        }
        // console.log(scheduleinminutes);
        fillOccupationSchedule('monday', 0, scheduleinminutes, occupationschedule);
        fillOccupationSchedule('tuesday', 1, scheduleinminutes, occupationschedule);
        fillOccupationSchedule('wednesday', 2, scheduleinminutes, occupationschedule);
        fillOccupationSchedule('thursday', 3, scheduleinminutes, occupationschedule);
        fillOccupationSchedule('friday', 4, scheduleinminutes, occupationschedule);
        fillOccupationSchedule('saturday', 5, scheduleinminutes, occupationschedule);
        fillOccupationSchedule('sunday', 6, scheduleinminutes, occupationschedule);
        //O : lundi -> 6 : dimanche
        let firstdate = usedata[0].timestamp;
        let lastdate = usedata[usedata.length - 1].timestamp;
        //console.log(firstdate, lastdate);
        let previousstate = 0;
        let timebegin = firstdate;
        let previousdate;
        for (let i = 0; i < usedata.length; i++) {
            let date = usedata[i].timestamp;
            let dayofweek = moment(date).utc().weekday();
            let hourofday = moment(date).utc().hour();
            let minuteofhour = moment(date).utc().minute();
            let minuteofweek = (dayofweek * 24 * 60) + (hourofday * 60) + minuteofhour;
            let occupationscheduleslot = scheduleinminutes.find((obj) => obj.timeofweek == minuteofweek);
            let state = occupationscheduleslot.now;
            if (state != previousstate || i == (usedata.length - 1)) {
                // console.log('statedif', state, previousstate, date, occupationscheduleslot.before);
                let timeendbefore = previousdate;
                let timeend = date;
                if (timebegin != timeend) {
                    let color = "#8bbc21";
                    if (previousstate == 1) {
                        color = "#8bbc21"; //green         
                        if (occupationscheduleslot.before != 1) //part of slot is off
                        {
                            let area = <ReferenceArea x1={timebegin} x2={timeendbefore} ifOverflow='hidden' yAxisId={'left'} fill={color} opacity='0.35' />; //stop at previous slot for full color
                            occupationareas.push(area);
                            timebegin = timeendbefore;
                            color = "url(#greentored)"
                        }
                    }
                    else if (previousstate == 0) {
                        color = "#c42525";
                        if (occupationscheduleslot.before != 0) //part of slot is on
                        {
                            let area = <ReferenceArea x1={timebegin} x2={timeendbefore} ifOverflow='hidden' yAxisId={'left'} fill={color} opacity='0.35' />; //stop at previous slot for full color
                            occupationareas.push(area);
                            timebegin = timeendbefore;
                            color = "url(#redtogreen)"
                        }
                    }
                    let area = <ReferenceArea x1={timebegin} x2={timeend} ifOverflow='hidden' yAxisId={'left'} fill={color} opacity='0.35' />;
                    occupationareas.push(area);
                }
                timebegin = timeend;
            }
            previousdate = date;
            previousstate = state;
            // console.log(date, dayofweek, minuteofweek);
        }
    }
    return occupationareas;
}

const fillOccupationSchedule = (daystr, dayint, scheduleinminutes, occupationschedule) => {
    if (occupationschedule[daystr + 'schedulestart']) {
        let split = occupationschedule[daystr + 'schedulestart'].split(":");
        let hour = Number(split[0]);
        let minute = Number(split[1]);
        let timeofweek = (dayint * 60 * 24) + (hour * 60) + minute;
        scheduleinminutes.find((obj) => obj.timeofweek == timeofweek).now = 1;
        let timeofweekend = (dayint * 60 * 24) + (23 * 60) + 59; //if no end it will be at end of the day
        if (occupationschedule[daystr + 'scheduleend']) {
            let splitend = occupationschedule[daystr + 'scheduleend'].split(":");
            let hourend = Number(splitend[0]);
            let minuteend = Number(splitend[1]);
            timeofweekend = (dayint * 60 * 24) + (hourend * 60) + minuteend;
        }
        timeofweek++;
        for (let i = timeofweek; i < timeofweekend; i++) {
            let slot = scheduleinminutes.find((obj) => obj.timeofweek == i);
            slot.before = 1;
            slot.now = 1;
        }
        scheduleinminutes.find((obj) => obj.timeofweek == timeofweekend).before = 1;
    }
}